import { DvaReducer } from '@/models/shared';
import { Subscription, SubscriptionAPI } from 'dva';
import type { ResourceCreatorPageModelType, ChangeAction } from './types';
import { initialState } from './initialState';
import { pageEffects } from './pageEffects';
import { step1Effects } from './step1Effects';
import { step2Effects } from './step2Effects';
import { step3Effects } from './step3Effects';
import { step4Effects } from './step4Effects';

export * from './types';

const Model: ResourceCreatorPageModelType = {
  namespace: 'resourceCreatorPage',
  state: initialState,
  effects: {
    ...pageEffects,
    ...step1Effects,
    ...step2Effects,
    ...step3Effects,
    ...step4Effects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({ dispatch, history }: SubscriptionAPI) {},
  },
};

export default Model;
